// src/context/NavigationContext.jsx
// Works with @shopify/app-bridge-react v4.2.7 + CDN App Bridge
import React, { createContext, useContext, useCallback } from 'react';
import { useNavigate as useRouterNavigate, useSearchParams } from 'react-router-dom';

const NavigationContext = createContext();

export const NavigationProvider = ({ children }) => {
  const routerNavigate = useRouterNavigate();
  const [searchParams] = useSearchParams();
  
  // Detect embedded mode
  const host = searchParams.get('host');
  const shop = searchParams.get('shop');
  const isEmbedded = !!host;
  
  // Create smart navigate function
  const navigate = useCallback((to, options = {}) => {
    console.log('[NavigationContext] Navigating to:', to, 'Embedded:', isEmbedded);
    
    if (isEmbedded) {
      // For embedded apps, use standard React Router navigation
      // The browser history will work inside the iframe
      const separator = to.includes('?') ? '&' : '?';
      const fullUrl = `${to}${separator}shop=${shop}&host=${host}`;
      
      console.log('[NavigationContext] Embedded navigation to:', fullUrl);
      routerNavigate(fullUrl, options);
    } else {
      // Standard navigation for non-embedded
      console.log('[NavigationContext] Standard navigation to:', to);
      routerNavigate(to, options);
    }
  }, [isEmbedded, shop, host, routerNavigate]);
  
  return (
    <NavigationContext.Provider value={{ navigate, isEmbedded }}>
      {children}
    </NavigationContext.Provider>
  );
};

// Custom hook that replaces useNavigate
export const useNavigate = () => {
  const context = useContext(NavigationContext);
  const routerNavigate = useRouterNavigate();
  
  if (!context) {
    console.warn('[NavigationContext] Used outside provider, falling back to router navigate');
    return routerNavigate;
  }
  
  return context.navigate;
};

// Export a flag to check if embedded
export const useIsEmbedded = () => {
  const context = useContext(NavigationContext);
  return context?.isEmbedded || false;
};